import { Row, Col, Form, Button, Modal } from 'react-bootstrap';
import "./NewUserModal.css"
import { useState } from 'react';
import Swal from "sweetalert2";
import Select from 'react-select';



const NewCustomerModal = ({ show, requestClose }) => {

    //ENV VARIABLE
    const apiUrl = process.env.REACT_APP_API_URL;
    const backendAPI_Key = process.env.REACT_APP_API_KEY;

    //INPUTS CONTROLS
    const [name, setName] = useState(null);
    const [userMail, setUserMail] = useState(null);
    const [userCompany, setUserCompany] = useState(null);

    const onShowModal = async () => {

        setUserCompany(1);

    }

    const addNewCustomer = async () => {

        //EMPRESA O NOMBRE
        if(!name){

            //Show message sweet alert
            Swal.fire({
                title: "Datos Faltantes",
                text: "Debe indicar el nombre del cliente.",
                icon: "warning",
                confirmButtonText: "OK"
            });

            return;

        }


        //USERNAME
        let userNameRandom = Math.random().toString().split(".")[1];


        const metadata = {
            "customer_name": name,
            "email": userMail,
            "username": userNameRandom.toString(),
            "grouP_ID": 2001,
            "is_company":userCompany,
            "observations":""
        };

        const endpoint = "addUser";

        const response = await fetch(apiUrl + endpoint,
        {
            method: "POST",
            headers: {"Content-Type": "application/json", "X-API-KEY" : backendAPI_Key},
            body: JSON.stringify(metadata)
        });

        const responseContent = await response.json();

        if(responseContent.code == 403){

            Swal.fire({
                title: "Error!",
                text: "El username ya se encuentra en la base de datos.",
                icon: "error",
                confirmButtonText: "OK"
            });

        } else if(responseContent.code == 500){

            //Show message sweet alert
            Swal.fire({
                title: "Error!",
                text: responseContent.message,
                icon: "error",
                confirmButtonText: "OK"
            });


        } else if(responseContent.code == 200){

            //Show message sweet alert
            Swal.fire({
                title: "¡Éxito!",
                text: "Operación realizada exitosamente.",
                icon: "success",
                confirmButtonText: "OK"
            });

            //CLOSE MODAL
            requestClose(false);

        }

    } //
    


    return (
        <>
        <Modal show={show} onShow={onShowModal} onHide={requestClose} className={'mainOrderModal'} style={{marginTop: "20px"}} size="md">
            <Modal.Header closeButton style={{borderTop:'10px solid #404661', backgroundColor: "#ced0d9"}}>
                <Modal.Title className={'newOrderTitle'}>
                    Agregar Nuevo Cliente <br />
                </Modal.Title>
            </Modal.Header>
            <Modal.Body style={{backgroundColor: "#dfe0e6", borderTop: "1px solid white"}}>
                <Form>
                <Row>
                    <Col xs={12}>
                        <Form.Label className={'newOrderlabels'}>Tipo de Cliente</Form.Label>
                            <Form.Select style={{fontSize:"14px"}} onChange={(e)=>{setUserCompany(e.target.value); }}>
                                <option style={{fontSize:"14px"}} value="1" selected>Persona Jurídica</option>
                                <option style={{fontSize:"14px"}} value="0">Consumidor Final</option>
                            </Form.Select> <br />
                    </Col>

                    <Col xs={12}>
                        <Form.Group>
                             <Form.Label className={'newOrderlabels'}>
                                { userCompany === "0" ? "Nombre Cliente" : "Empresa" }
                            </Form.Label>
                             <Form.Control 
                             type="text" 
                             placeholder= { userCompany === "0" ? "Nombre Cliente..." : "Empresa..." }
                             onChange={(event)=> setName(event.target.value)} /><br />
                        </Form.Group>
                    </Col>

                    <Col xs={12}>
                        <Form.Group>
                             <Form.Label className={'newOrderlabels'}>Contacto / E-Mail</Form.Label>
                             <Form.Control 
                             type="text" 
                             placeholder="E-Mail" 
                             onChange={(event)=> setUserMail(event.target.value)} /><br />
                        </Form.Group>
                    </Col>

                </Row>
                </Form>
            </Modal.Body>
            <Modal.Footer style={{backgroundColor: "#ced0d9"}}>
            <Button variant="danger" onClick={requestClose} size='sm'>
                Cerrar Ventana
            </Button>
            <Button 
                variant="success" 
                size='sm'
                onClick={addNewCustomer}
                >

                Guardar Datos
            </Button>
            </Modal.Footer>
        </Modal>



        </>
    );
}

export default NewCustomerModal;